import { useLocale } from '@gov-nx/core/service';
import {
	formatPersonLabel,
	useProfilROSDetailContext,
} from '@gov-nx/module/page';
import { DataTable, Dialog, LayoutGap } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';

export const PersonsListModal = () => {
	const { isPersonsListModalOpen, persons, code } = useProfilROSDetailContext();
	const { t } = useLocale(code);

	return (
		<Dialog
			isOpen={isPersonsListModalOpen.isTrue}
			onClose={isPersonsListModalOpen.setFalse}
			title={<h3>{t('modal.label.osoby')}</h3>}>
			<LayoutGap>
				<p>{t('modal.popis.osoby')}</p>
				<ol>
					{persons.map((person) => (
						<li
							key={[
								person.ico,
								person.sidloSpolecnosti?.adresaText,
								person.datumNarozeni,
							].join(',')}>
							<DataTable responsive>
								<tbody>
									<tr>
										<td className="sm:w-1/2">{t('modal.zaznam.jmeno')}</td>
										<td className="sm:w-1/2">
											<strong>{formatPersonLabel(person)}</strong>
										</td>
									</tr>
									<tr>
										<td>{t('modal.zaznam.adresa-pobytu')}</td>
										<td>
											<strong>
												{person?.sidloSpolecnosti?.adresaText ?? '-'}
											</strong>
										</td>
									</tr>
									<tr>
										<td>{t('modal.zaznam.datum-narozeni')}</td>
										<td>
											<strong>
												{person?.datumNarozeni
													? toDateReadable(person.datumNarozeni)
													: '-'}
											</strong>
										</td>
									</tr>
								</tbody>
							</DataTable>
						</li>
					))}
				</ol>
			</LayoutGap>
		</Dialog>
	);
};
